import { COLORS } from "../../../../utils/colors"

export const useCalendarStyles = () => {
    return {
      global : {
        '.rbc-show-more': {
          display: 'none !important',
        },
        '.rbc-show-more:hover': {
          backgroundColor: 'transparent',
          color: COLORS.DARK_GREY,
        },
        '.rbc-today': {
          backgroundColor: 'transparent !important',
          border: `2px solid ${COLORS.DARK_GREY}`,
          borderRadius: '0.4rem',
          borderLeft: `2px solid ${COLORS.DARK_GREY} !important`,
          '&:hover': {
            backgroundColor: `${COLORS.LIGHT_GRAY} !important`,
          },
        },
        '.rbc-day-bg': {
          '&:hover': {
            backgroundColor: COLORS.LIGHT_GRAY,
          },
        },
      },
      calendarContainer: {
 
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 3.5rem)',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        padding: '1rem',
        paddingTop: '0rem',
        backgroundColor: COLORS.WHITE,
        boxShadow:
          '0 5px 15px 0 rgba(0, 0, 0, 0.07), 0 10px 25px 0 rgba(50, 50, 93, 0.07)',
      },
      showMoreButton: {
        position: 'absolute',
        top: '4.7rem',
        display: 'flex',
        justifyContent: 'flex-start',
        fontSize: '12px',
        textTransform : 'none',
        color: COLORS.DARK_GREY

      },
      toolTipContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        overflow: 'hidden',
        flexGrow: 1,
        marginBottom: 'auto',
      },
      toolbarContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: '100%'
      },
      navigationContainer: {
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      navigationTitle: {
        textAlign: "center",
        fontSize: "1.2rem",
        fontFamily: 'Montserrat',
        color: '#53617a'
      },
      eventContainer: {
        display: 'flex',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        padding: '0px !important',
        alignItems: 'center',
      },
      today: {
        backgroundColor: '#fff' ,
        textTransform: 'none',
        color: '#0b1339',
        borderRadius: '2rem',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        fontSize: '0.8rem',
        border: '1px solid #0b1339',
        marginRight: '1rem'
    },
    customToolbarContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    switchStyles: {
      fontSize: '13px',
      '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
          color: COLORS.PRIMARY,
        },
        '&.Mui-checked + .MuiSwitch-track': {
          backgroundColor: COLORS.PRIMARY,
        },
      },
      '& .MuiSwitch-track': {
        backgroundColor: COLORS.PRIMARY,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: COLORS.PRIMARY,
      },
    },
    eventDate: {
      fontSize: '0.7rem', marginRight: '0.4rem'
    },
    eventTitle: {
      fontSize: '0.7rem', fontWeight: '500', cursor: 'pointer' 
    },
    weekDayViewContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      width: '100%',
    },
    weekDayViewTitle: {
      fontSize: '0.65rem',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    weekDayViewTime: {
      fontSize: '0.65rem',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.2rem',
    },
    customCellContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      margin: '0.2rem'
    },
    dayStyles: {
      width: '1.688rem',
      height: '1.688rem',
      padding: '0.2rem',
      fontSize: '1rem',
      display: 'flex',
      justifyContent: 'center',
      borderRadius: '3rem',
    }
    }
}